"use client"

import { PublicErrorBoundary } from "@/components/public-error-boundary"

export default function MoscowError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return <PublicErrorBoundary error={error} reset={reset} source="moscow-error-boundary" mode="graceful" />
}
